import { Chip } from "@mui/material";

const STATUS_MAP: Record<number, { text: string; color: string }> = {
  1: { text: "Pending Payment", color: "#F2D8B0" },
  2: { text: "Payment Failed", color: "#FFB2B2" },
  3: { text: "Paid", color: "#D9F9BA" },
  4: { text: "Refunded", color: "#B0F2D2" },
  5: { text: "Processing", color: "#D7FFD9" },
  6: { text: "Refund Failed", color: "#FFB2B2" },
};

export default function BadgePayment(props: any) {
    const {
        id = 1
    } = props;
    
  const status = STATUS_MAP[id] ?? STATUS_MAP[1];

  return (
    <Chip
      label={`○ ${status.text}`}
      className="order-details-status"
      style={{
        borderRadius: "5px",
        fontSize: "14px",
        backgroundColor: status.color,
        color: "#424242",
        fontWeight: "400",
        height: "29px",
      }}
    />
  );
}